import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import util from "../util/util";

export default function RuleDetailExceptions(props) {
  return props.pod || props.campaign ? (
    <div>
      <h4 className="page__header">Source {props.pod ? `Pod` : `Campaign`}</h4>
      <p>
        {props.pod ? (
          <Link to={util.returnPodDetailUrl(props.pod.id)}>
            {props.pod.name}
          </Link>
        ) : (
          <Link to={util.returnCampaignDetailUrl(props.campaign.id)}>
            {props.campaign.name}
          </Link>
        )}
      </p>
    </div>
  ) : null;
}

RuleDetailExceptions.propTypes = {
  pod: PropTypes.object,
  campaign: PropTypes.object
};
